<template>
  <div>
    <label class="block mb-2 text-sm font-medium text-gray-900">
      Charge on Renewal
    </label>
    <CurrencyInput
      :value="value"
      @price-change="(cents) => emit('price-change', cents)"
    />
    <p v-if="errorMessage" class="mt-1 text-xs text-red-600">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import CurrencyInput from "serviceshift-ui/components/Inputs/CurrencyInput.vue";

// Charge-on-Renewal field for the membership forms. Wraps the shared
// v-money3 CurrencyInput (cents in/out, reactive to programmatic value
// changes) with the label and gray styling the form expects — the previous
// sera-input-currency web component did not re-render on programmatic value
// changes, so editing covered systems or switching programs left a stale
// price on screen.
defineProps<{
  value: number;
  errorMessage?: string;
}>();

const emit = defineEmits<{
  "price-change": [cents: number];
}>();
</script>

<style scoped lang="scss">
// CurrencyInput renders a v-money3 <input class="price-input">; match the gray
// Tailwind inputs (date pickers / stepper) beside it in the row.
:deep(.price-input) {
  width: 100%;
  height: 40px; // h-10
  padding: 0 0.75rem;
  font-size: 0.875rem; // text-sm
  color: #111827; // gray-900
  background-color: #f9fafb; // gray-50
  border: 1px solid #d1d5db; // gray-300
  border-radius: 0.5rem; // rounded-lg
}

:deep(.price-input:focus) {
  outline: none;
  border-color: #3b82f6; // blue-500
  box-shadow: 0 0 0 1px #3b82f6;
}
</style>
